import React, { useMemo } from 'react'
import { useS4LContext } from '@s4l/react-context'

import { Typography } from '@s4l/ds'
import Price from 'client/components/Price'

import { Line } from '../styles'

interface TravelInsuranceLineProps {
  additionalProducts?: Record<string, number>
  currency: string
}

const getBattlefaceLabel = (key: string) => {
  const labelMap: Record<string, string> = {
    battleface_tripCancellation: 'insurance-package.essential',
    battleface_base: 'insurance-package.advanced',
    battleface_comprehensive: 'insurance-package.complete',
  }
  const baseKey = key.includes('_') ? key.slice(0, key.lastIndexOf('_')) : key
  return labelMap[baseKey] || key
}

const TravelInsuranceLine = ({ additionalProducts, currency }: TravelInsuranceLineProps) => {
  const { i18n } = useS4LContext()

  const battlefaceProducts = useMemo(
    () =>
      additionalProducts
        ? Object.entries(additionalProducts).filter(
            ([key, value]) => key.startsWith('battleface') && typeof value === 'number' && value > 0
          )
        : [],
    [additionalProducts]
  )

  if (battlefaceProducts.length === 0) {
    return null
  }

  return (
    <>
      {battlefaceProducts.map(([key, value], index) => (
        <Line key={key} variant={index < battlefaceProducts.length - 1 ? 'nopadding' : undefined}>
          <Typography variant="body" size="l">
            {i18n.formatMessage(
              {
                id: 'insurance-package.summary',
              },
              { insurance: i18n.formatMessage({ id: getBattlefaceLabel(key) }) }
            )}
          </Typography>
          <Typography variant="body" size="l">
            <Price amount={value} currency={currency} />
          </Typography>
        </Line>
      ))}
    </>
  )
}

export default TravelInsuranceLine
